import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  name: {
    name: "name",
    label: "Name",
    type: "text",
    errorMsg: "Name is required.",
    required: true,
    maxLength: 50,
  },
  range: {
    name: "range",
    label: "Range",
    type: "text",
    errorMsg: "Range is required.",
    required: true,
  },
};

const { name, range } = formField;

export const formRender = [[name], [range]];

export const initialValues = getInitialValues(formField);

export const kpiProductivityRangeValidation = Yup.object().shape({
  [name.name]: Yup.string().nullable().max(name.maxLength).required(name.errorMsg),
  [range.name]: Yup.string().nullable().required(range.errorMsg),
});
